export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const faqList: FAQ[] = [
  {
    id: 'faq-1',
    question: '91制片厂是什么平台？',
    answer: '91制片厂是一个专注优质影视内容创作与发行的专业平台。我们汇聚了大量原创视频资源，涵盖动作片、剧情片、纪录片、喜剧片、悬疑片、科幻片等多种类型，为用户提供高清流畅的观影体验。所有内容均为正版授权，确保观众享受到的每一部作品都经过严格品质把控。',
  },
  {
    id: 'faq-2',
    question: '如何成为91制片厂的会员？',
    answer: '您可以通过我们的官方网站在线注册会员。会员分为月度会员、季度会员和年度会员三种方案。成为会员后，您将享有高清无广告观影、独家原创内容抢先看、会员专属活动参与权等多项特权。新用户注册还可享受首月优惠体验价。',
  },
  {
    id: 'faq-3',
    question: '支持哪些设备观看？',
    answer: '91制片厂支持全平台观看，包括Web网页端、iOS/Android手机App、iPad平板端以及智能电视TV端。您可以随时随地通过任意设备畅享高清影视内容，观影进度会自动云端同步，让您在不同设备间无缝切换。',
  },
  {
    id: 'faq-4',
    question: '视频画质最高支持多少？',
    answer: '91制片厂平台最高支持4K超高清画质，部分精选内容提供8K版本。画面清晰度会根据您的网络状况自动调节，同时也支持手动选择画质。建议在Wi-Fi环境下选择最高画质以获得最佳观影体验。',
  },
  {
    id: 'faq-5',
    question: '可以下载影片离线观看吗？',
    answer: '是的，会员用户可以将影片下载到移动设备上进行离线观看。下载的影片在会员有效期内可以随时观看。离线下载功能目前支持手机App端和Pad端，下载的影片会进行加密保护，确保版权安全。',
  },
  {
    id: 'faq-6',
    question: '怎样联系客服？',
    answer: '您可以通过以下方式联系我们的客服团队：在线客服（工作日9:00-21:00）、官方邮箱service@91pianzhi.com，以及官方微信公众号"91制片厂"。我们承诺在工作时间内2小时内响应您的咨询。紧急问题也可拨打客服热线400-xxx-xxxx。',
  },
  {
    id: 'faq-7',
    question: '91制片厂的内容是否为正版？',
    answer: '91制片厂平台上的所有影视作品均为正版授权内容。我们与国内外多家知名影视制作公司、独立制片人和版权方建立了深度合作关系，严格遵循知识产权保护法律法规。所有上线内容均经过版权审核，确保100%正版合规。',
  },
  {
    id: 'faq-8',
    question: '如何向91制片厂投稿原创作品？',
    answer: '我们热烈欢迎优秀的原创影视作品投稿！您可以通过官方网站的"创作者入驻"页面提交作品信息和样片。我们的内容审核团队会在5个工作日内进行评审并给予反馈。对于优秀的原创作品，我们将提供制作资源支持、宣发推广和收益分成等合作方案。',
  },
];